import axios from 'axios';

// eslint-disable-next-line import/prefer-default-export
export async function getEvents(params = {}) {
  try {
    let assettype;
    if (params.assettype === 'film') {
      assettype = params.parenteventid ? 'video' : 'footage';
    } else {
      assettype = 'images';
    }
    const url = params.parenteventid
      ? `/editorial-${assettype}/${params.editorialproducts}/events/${params.urlslug}/${params.parenteventid}`
      : `/editorial-${assettype}/${params.editorialproducts}`;
    const response = await axios.get(url, {
      params: {
        page: params.page,
        pagesize: params.pagesize,
      },
      headers: {
        Accept: 'application/json',
      },
    });

    return response.data.events;
  } catch (error) {
    console.log('EventService - Error fetching Events', error);
    return [];
  }
}
